/* CENIT · Header, menú y carrito lateral. Antes vivía dentro de sections/cenit-header.liquid. */
(function(){

  function cenitRoot(){
    return (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    )
      ? Shopify.routes.root
      : '/';
  }


  function cenitHeaderMoney(cents){

    return new Intl.NumberFormat(
      'es-MX',
      {
        style:'currency',
        currency:'MXN'
      }
    ).format(
      (cents || 0) / 100
    );

  }


  /* 3x2 acumulable en pantalla: por cada 3 piezas, una gratis (6x4, 9x6...). Las gratis son las de menor precio.
     Si la promo está encendida y Shopify todavía no devuelve el descuento, el tema hace la cuenta para que
     el ahorro se vea desde el carrito. Cuando el descuento automático existe, Shopify manda total_discount
     y esto no hace nada. */
  function cenitApply3x2(cart){
    var bar = document.querySelector('[data-cenit-shipbar]');
    if(!bar || bar.getAttribute('data-x32') !== '1') return;
    if(!cart || cart._x32 || !cart.items || (Number(cart.total_discount) || 0) > 0) return;
    var free = Math.floor((Number(cart.item_count) || 0) / 3);
    if(free < 1) return;
    var lines = cart.items
      .map(function(item){ return { item: item, unit: Number(item.final_price || item.price) || 0 }; })
      .filter(function(l){ return l.unit > 0; })
      .sort(function(x, y){ return x.unit - y.unit; });
    var off = 0;
    lines.forEach(function(l){
      if(free < 1) return;
      var take = Math.min(free, Number(l.item.quantity) || 1);
      var line = typeof l.item.final_line_price === 'number' ? l.item.final_line_price : (l.item.line_price || 0);
      if(!l.item.original_line_price) l.item.original_line_price = line;
      l.item.final_line_price = Math.max(0, line - take * l.unit);
      l.item.line_price = l.item.final_line_price;
      l.item._x32Free = take;
      off += take * l.unit;
      free -= take;
    });
    if(!off) return;
    cart.total_discount = off;
    cart.total_price = Math.max(0, (Number(cart.total_price) || 0) - off);
    cart._x32 = true;
  }


  /* Precio de una línea del carrito: marca los regalos y los descuentos automáticos */
  function cenitLinePrice(item){
    var fin = typeof item.final_line_price === 'number' ? item.final_line_price : (item.line_price || 0);
    var orig = item.original_line_price || 0;
    if(fin === 0 && orig > 0){
      return '<span class="cenit-cart-drawer__gift">Gratis · 3x2</span> <s>' + cenitHeaderMoney(orig) + '</s>';
    }
    if(fin < orig){
      return '<span>' + cenitHeaderMoney(fin) + '</span> <s>' + cenitHeaderMoney(orig) + '</s>' +
        (item._x32Free ? ' <span class="cenit-cart-drawer__gift">' + item._x32Free + ' gratis</span>' : '');
    }
    return '<span>' + cenitHeaderMoney(fin) + '</span>';
  }


  function cenitHeaderMoneyCompact(cents){

    return new Intl.NumberFormat(
      'es-MX',
      {
        style:'currency',
        currency:'MXN',
        maximumFractionDigits:0
      }
    ).format(
      (cents || 0) / 100
    );

  }


  function cenitEscapeHtml(value){

    return String(
      value == null
        ? ''
        : value
    )
    .replace(/&/g,'&amp;')
    .replace(/</g,'&lt;')
    .replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;')
    .replace(/'/g,'&#039;');

  }


  function cenitCartImageUrl(url){

    if(!url){
      return '';
    }

    try{
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width','600');
      return u.toString();
    }catch(e){
      return url;
    }

  }


  function cenitFetchCart(){

    return fetch(
      cenitRoot() + 'cart.js',
      {
        headers:{
          'Accept':'application/json'
        }
      }
    )
    .then(
      function(response){

        if(!response.ok){
          throw new Error(
            'No se pudo cargar el carrito.'
          );
        }

        return response.json();

      }
    );

  }



  /* ========================================================
     BUSCADOR PREDICTIVO
  ======================================================== */

  var cenitSearchTimer = null;
  var cenitSearchController = null;

  function cenitSearchMoney(cents){
    return new Intl.NumberFormat('es-MX',{
      style:'currency',
      currency:'MXN',
      maximumFractionDigits:0
    }).format((Number(cents) || 0) / 100);
  }

  function cenitSearchProductCard(product){
    var title = cenitEscapeHtml(product.title || '');
    var url = cenitEscapeHtml(product.url || '#');
    var imageUrl = '';

    if(product.featured_image && product.featured_image.url){
      imageUrl = product.featured_image.url;
    }else if(product.image){
      imageUrl = product.image;
    }

    if(imageUrl){
      try{
        var u = new URL(imageUrl, window.location.origin);
        u.searchParams.set('width','640');
        imageUrl = u.toString();
      }catch(e){}
    }

    return (
      '<a class="cenit-search-product" href="' + url + '">' +
        '<div class="cenit-search-product__media">' +
          (imageUrl
            ? '<img src="' + cenitEscapeHtml(imageUrl) + '" alt="' + title + '" loading="lazy" decoding="async">'
            : '') +
        '</div>' +
        '<div class="cenit-search-product__body">' +
          '<span class="cenit-search-product__name">' + title + '</span>' +
          '<span class="cenit-search-product__price">' + cenitSearchMoney(product.price) + ' MXN</span>' +
        '</div>' +
      '</a>'
    );
  }

  function cenitRenderSearchLoading(){
    var body = document.getElementById('cenitSearchBody');
    if(body){
      body.innerHTML = '<div class="cenit-search-state"><span class="cenit-search-spinner" aria-hidden="true"></span></div>';
    }
  }

  function cenitRenderSearchResults(query, products){
    var body = document.getElementById('cenitSearchBody');
    if(!body) return;

    if(!products || !products.length){
      body.innerHTML =
        '<div class="cenit-search-state">No encontramos resultados para “' +
        cenitEscapeHtml(query) +
        '”.</div>';
      return;
    }

    body.innerHTML =
      '<div class="cenit-search-results-head">' +
        '<h3>Resultados</h3>' +
        '<span>' + products.length + (products.length === 1 ? ' pieza' : ' piezas') + '</span>' +
      '</div>' +
      '<div class="cenit-search-grid">' +
        products.map(cenitSearchProductCard).join('') +
      '</div>' +
      '<a class="cenit-search-all" href="/search?q=' + encodeURIComponent(query) + '">' +
        'Ver todos los resultados <span>→</span>' +
      '</a>';
  }

  function cenitPredictiveSearch(query){
    query = String(query || '').trim();

    var clear = document.getElementById('cenitSearchClear');
    if(clear) clear.classList.toggle('visible', query.length > 0);

    if(query.length < 2){
      if(cenitSearchController) cenitSearchController.abort();

      var body = document.getElementById('cenitSearchBody');
      if(body){
        body.innerHTML =
          '<div class="cenit-search-state">Escribe al menos 2 letras para buscar.</div>';
      }
      return;
    }

    cenitRenderSearchLoading();

    if(cenitSearchController) cenitSearchController.abort();
    cenitSearchController = new AbortController();

    var url =
      cenitRoot() +
      'search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url,{
      headers:{'Accept':'application/json'},
      signal:cenitSearchController.signal
    })
    .then(function(response){
      if(!response.ok) throw new Error('No se pudo buscar.');
      return response.json();
    })
    .then(function(data){
      var products =
        data &&
        data.resources &&
        data.resources.results &&
        data.resources.results.products
          ? data.resources.results.products
          : [];

      cenitRenderSearchResults(query, products);
    })
    .catch(function(error){
      if(error && error.name === 'AbortError') return;

      var body = document.getElementById('cenitSearchBody');
      if(body){
        body.innerHTML =
          '<div class="cenit-search-state">No pudimos cargar la búsqueda. Intenta de nuevo.</div>';
      }
    });
  }

  window.cenitOpenSearch = function(){
    if(typeof window.cenitCloseDrawer === 'function') window.cenitCloseDrawer();
    if(typeof window.cenitCloseAccountMenu === 'function') window.cenitCloseAccountMenu();

    var overlay = document.getElementById('cenitSearchOverlay');
    var input = document.getElementById('cenitSearchInput');
    var trigger = document.querySelector('.cenit-header__search-btn');

    if(!overlay) return;

    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden','false');
    if(trigger) trigger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';

    if(input && !input.value.trim()) cenitSearchIdle();

    setTimeout(function(){
      if(input) input.focus();
    },180);
  };

  window.cenitCloseSearch = function(){
    var overlay = document.getElementById('cenitSearchOverlay');
    var trigger = document.querySelector('.cenit-header__search-btn');

    if(!overlay) return;

    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden','true');
    if(trigger) trigger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  };

  window.cenitSearchOverlayClick = function(event){
    if(event.target && event.target.id === 'cenitSearchOverlay'){
      window.cenitCloseSearch();
    }
  };

  window.cenitClearSearch = function(){
    var input = document.getElementById('cenitSearchInput');
    var body = document.getElementById('cenitSearchBody');
    var clear = document.getElementById('cenitSearchClear');

    if(input){
      input.value = '';
      input.focus();
    }
    if(clear) clear.classList.remove('visible');
    if(body){
      body.innerHTML =
        '<div class="cenit-search-state">Busca por nombre, color, tipo de pieza o constelación.</div>';
    }
    cenitSearchIdle();
  };

  function cenitInitSearch(){
    var input = document.getElementById('cenitSearchInput');

    if(!input || input.dataset.cenitReady === '1') return;

    input.dataset.cenitReady = '1';

    input.addEventListener('input',function(){
      var value = input.value;

      if(cenitSearchTimer) clearTimeout(cenitSearchTimer);

      cenitSearchTimer = setTimeout(function(){
        cenitRunSearch(value);
      },140);
    });

    var form = input.closest('form');
    if(form){
      form.addEventListener('submit',function(event){
        var smart = window.cenitSmartSearch;
        var target = smart ? smart.submitUrl(input.value.trim()) : null;
        if(target){
          event.preventDefault();
          window.location.href = target;
        }
      });
    }

    var body = document.getElementById('cenitSearchBody');
    if(body){
      body.addEventListener('click',function(event){
        var chip = event.target.closest('[data-cs-q]');
        if(!chip) return;
        input.value = chip.getAttribute('data-cs-q');
        cenitRunSearch(input.value);
        input.focus();
      });
    }
  }

  /* Buscador CENIT (assets/cenit-search.js); si su índice no carga, usa la búsqueda predictiva de Shopify */
  function cenitSmartReady(){
    var smart = window.cenitSmartSearch;
    if(!smart) return null;
    if(!smart.configured){
      smart.configure(document.getElementById('cenitSearchOverlay'));
      smart.configured = true;
    }
    return smart;
  }

  function cenitSearchIdle(){
    var body = document.getElementById('cenitSearchBody');
    var smart = cenitSmartReady();
    if(!body || !smart) return;
    smart.idle(body).catch(function(){});
  }

  function cenitRunSearch(value){
    var query = String(value || '').trim();
    var clear = document.getElementById('cenitSearchClear');
    var body = document.getElementById('cenitSearchBody');
    var smart = cenitSmartReady();

    if(clear) clear.classList.toggle('visible', query.length > 0);
    if(!smart){
      cenitPredictiveSearch(query);
      return;
    }
    if(!query){
      cenitSearchIdle();
      return;
    }
    smart.query(query, body).catch(function(){
      cenitPredictiveSearch(query);
    });
  }


  /* ========================================================
     MOUNT DRAWERS A BODY
  ======================================================== */

  function cenitMountDrawer(){

    var drawer =
      document.getElementById(
        'cenitDrawer'
      );

    var overlay =
      document.getElementById(
        'cenitOverlay'
      );


    if(
      !drawer ||
      !overlay
    ){
      return;
    }


    if(
      overlay.parentElement !==
      document.body
    ){
      document.body.appendChild(
        overlay
      );
    }


    if(
      drawer.parentElement !==
      document.body
    ){
      document.body.appendChild(
        drawer
      );
    }

  }


  function cenitMountAccountMenu(){

    var menu =
      document.getElementById(
        'cenitAccountMenu'
      );

    var overlay =
      document.getElementById(
        'cenitAccountOverlay'
      );


    if(
      !menu ||
      !overlay
    ){
      return;
    }


    if(
      overlay.parentElement !==
      document.body
    ){
      document.body.appendChild(
        overlay
      );
    }


    if(
      menu.parentElement !==
      document.body
    ){
      document.body.appendChild(
        menu
      );
    }

  }


  /* ========================================================
     OPEN / CLOSE
  ======================================================== */

  window.cenitOpenDrawer =
    function(){

      cenitMountDrawer();

      if(
        typeof window.cenitCloseAccountMenu ===
        'function'
      ){
        window.cenitCloseAccountMenu();
      }


      var drawer =
        document.getElementById(
          'cenitDrawer'
        );

      var overlay =
        document.getElementById(
          'cenitOverlay'
        );


      if(
        !drawer ||
        !overlay
      ){
        return;
      }


      drawer.classList.add(
        'open'
      );

      overlay.classList.add(
        'open'
      );

      document.body.style.overflow =
        'hidden';

    };


  window.cenitCloseDrawer =
    function(){

      var drawer =
        document.getElementById(
          'cenitDrawer'
        );

      var overlay =
        document.getElementById(
          'cenitOverlay'
        );


      if(
        !drawer ||
        !overlay
      ){
        return;
      }


      drawer.classList.remove(
        'open'
      );

      overlay.classList.remove(
        'open'
      );

      document.body.style.overflow =
        '';

    };


  window.cenitOpenAccountMenu =
    function(){

      cenitMountAccountMenu();

      if(
        typeof window.cenitCloseDrawer ===
        'function'
      ){
        window.cenitCloseDrawer();
      }


      var menu =
        document.getElementById(
          'cenitAccountMenu'
        );

      var overlay =
        document.getElementById(
          'cenitAccountOverlay'
        );


      if(
        !menu ||
        !overlay
      ){
        return;
      }


      menu.classList.add(
        'open'
      );

      overlay.classList.add(
        'open'
      );

      menu.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.style.overflow =
        'hidden';


      cenitFetchCart()
      .then(
        function(cart){

          window.cenitUpdateCartHeader(
            cart
          );

        }
      )
      .catch(
        function(error){

          console.error(
            'CENIT: no se pudo actualizar el carrito',
            error
          );

        }
      );

    };


  window.cenitCloseAccountMenu =
    function(){

      var menu =
        document.getElementById(
          'cenitAccountMenu'
        );

      var overlay =
        document.getElementById(
          'cenitAccountOverlay'
        );


      if(
        !menu ||
        !overlay
      ){
        return;
      }


      menu.classList.remove(
        'open'
      );

      overlay.classList.remove(
        'open'
      );

      menu.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow =
        '';

    };


  /* ========================================================
     SHIPPING
  ======================================================== */

  function cenitUpdateShippingProgress(
    cart
  ){

    var bar =
      document.querySelector(
        '[data-cenit-shipbar]'
      );


    if(
      !bar ||
      !cart
    ){
      return;
    }


    var threshold =
      Number(
        bar.getAttribute(
          'data-threshold'
        )
      ) ||
      74900;


    var total =
      Math.max(
        0,
        Number(
          cart.total_price
        ) ||
        0
      );


    var remaining =
      Math.max(
        0,
        threshold -
        total
      );


    var percent =
      threshold > 0
        ? Math.min(
            100,
            (
              total /
              threshold
            ) *
            100
          )
        : 100;


    var text =
      bar.querySelector(
        '[data-cenit-ship-text]'
      );

    /* 3x2 acumulable: la barra cuenta piezas hacia la siguiente gratis */
    var count = Number(cart.item_count) || 0;
    var envioPiezas = Number(bar.getAttribute('data-envio-piezas')) || 0;
    var x32On = bar.getAttribute('data-x32') === '1';
    var resto = count % 3;
    var faltan = 3 - resto;
    if(x32On && count < 3){
      var fill32 = bar.querySelector('[data-cenit-ship-fill]');
      if(fill32) fill32.style.width = (count / 3 * 100).toFixed(1) + '%';
      bar.classList.remove('is-complete');
      if(text){
        text.innerHTML = count === 0
          ? '<b>3x2:</b> crea tu universo, lleva 3 y paga 2'
          : (count === 2 ? 'Agrega <b>1 pieza más</b> y te sale gratis' : 'Agrega <b>2 piezas más</b>: la tercera es gratis');
      }
      return;
    }
    if(x32On && resto > 0){
      var fillN = bar.querySelector('[data-cenit-ship-fill]');
      if(fillN) fillN.style.width = (resto / 3 * 100).toFixed(1) + '%';
      bar.classList.remove('is-complete');
      if(text){
        text.innerHTML = '<b>3x2 aplicado.</b> Agrega ' + (faltan === 1 ? '1 pieza más' : '2 piezas más') + ' y te llevas otra gratis';
      }
      return;
    }
    if(envioPiezas > 0 && count >= envioPiezas){
      remaining = 0;
      percent = 100;
    }


    var fill =
      bar.querySelector(
        '[data-cenit-ship-fill]'
      );


    if(fill){

      fill.style.width =
        percent.toFixed(1) +
        '%';

    }


    if(
      remaining <=
      0
    ){

      bar.classList.add(
        'is-complete'
      );


      if(text){

        text.innerHTML =
          (x32On && count >= 3 ? '<b>' + (count / 3 * 3) + 'x' + (count / 3 * 2) + ' aplicado</b> y envío gratis' : '<b>Envío gratis desbloqueado</b>');

      }

    }else{

      bar.classList.remove(
        'is-complete'
      );


      if(text){

        text.innerHTML =
          'Te faltan <b>' +
          cenitHeaderMoneyCompact(
            remaining
          ) +
          '</b> para envío gratis';

      }

    }

  }


  /* ========================================================
     ANNOUNCEMENTS
  ======================================================== */

  function cenitInitAnnouncements(){

    var wrap =
      document.querySelector(
        '[data-cenit-announcements]'
      );


    if(
      !wrap ||
      wrap.dataset.cenitReady ===
      '1'
    ){
      return;
    }


    var items =
      Array.prototype.slice.call(
        wrap.querySelectorAll(
          '[data-cenit-announcement]'
        )
      );


    if(!items.length){
      return;
    }


    wrap.dataset.cenitReady =
      '1';


    items.forEach(
      function(item,index){

        item.classList.toggle(
          'is-active',
          index === 0
        );

      }
    );


    if(
      items.length <
      2
    ){
      return;
    }


    if(
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ){
      return;
    }


    var current =
      0;


    wrap._cenitTimer =
      window.setInterval(
        function(){

          items[current]
          .classList.remove(
            'is-active'
          );


          current =
            (
              current +
              1
            ) %
            items.length;


          items[current]
          .classList.add(
            'is-active'
          );

        },
        4200
      );

  }


  /* ========================================================
     RENDER CART
  ======================================================== */

  function cenitRenderAccountCart(
    cart
  ){

    if(!cart){
      return;
    }


    var itemsEl =
      document.getElementById(
        'cenitAccountCartItems'
      );


    var countEl =
      document.getElementById(
        'cenitAccountCartCount'
      );


    var totalEl =
      document.getElementById(
        'cenitAccountCartTotal'
      );


    var checkoutEl =
      document.getElementById(
        'cenitAccountCheckout'
      );


    var piecesText =
      cart.item_count === 1
        ? 'pieza'
        : 'piezas';


    if(countEl){

      countEl.textContent =
        cart.item_count +
        ' ' +
        piecesText;

    }


    if(totalEl){

      totalEl.textContent =
        cenitHeaderMoney(
          cart.total_price
        );

    }

    /* Ahorro por promos automáticas (3x2) */
    var savedEl = document.getElementById('cenitAccountCartSaved');
    if(savedEl){
      var saved = Number(cart.total_discount) || 0;
      savedEl.hidden = saved <= 0;
      var savedOut = savedEl.querySelector('[data-cenit-saved]');
      if(savedOut) savedOut.textContent = cenitHeaderMoney(saved);
    }


    if(checkoutEl){

      if(
        cart.item_count >
        0
      ){

        checkoutEl.classList.remove(
          'is-disabled'
        );

        checkoutEl.removeAttribute(
          'aria-disabled'
        );

      }else{

        checkoutEl.classList.add(
          'is-disabled'
        );

        checkoutEl.setAttribute(
          'aria-disabled',
          'true'
        );

      }

    }


    if(!itemsEl){
      return;
    }


    if(
      !cart.items ||
      !cart.items.length
    ){

      itemsEl.innerHTML =
        '<div class="cenit-cart-drawer__empty">' +
          '<div class="cenit-cart-drawer__empty-icon">✦</div>' +
          '<div class="cenit-cart-drawer__empty-title">Tu cielo todavía está vacío</div>' +
          '<div class="cenit-cart-drawer__empty-text">Elige un anillo, collar o pulsera y aparecerá aquí.</div>' +
        '</div>';

      return;

    }


    itemsEl.innerHTML =
      cart.items.map(
        function(item){

          var title =
            cenitEscapeHtml(
              item.product_title ||
              item.title ||
              ''
            );


          var variant =
            item.variant_title &&
            item.variant_title !==
            'Default Title'
              ? '<div class="cenit-cart-drawer__item-variant">' +
                  cenitEscapeHtml(
                    item.variant_title
                  ) +
                '</div>'
              : '';


          var image =
            item.image
              ? '<img src="' +
                  cenitEscapeHtml(
                    cenitCartImageUrl(
                      item.image
                    )
                  ) +
                  '" alt="' +
                  title +
                  '" loading="lazy" decoding="async">'
              : '<span class="cenit-cart-drawer__image-empty">✦</span>';


          var itemUrl =
            cenitEscapeHtml(
              item.url ||
              '/cart'
            );


          var itemKey =
            cenitEscapeHtml(
              item.key ||
              ''
            );


          return (
            '<div class="cenit-cart-drawer__item-shell" data-cenit-cart-item data-cart-key="' +
              itemKey +
            '">' +

              '<div class="cenit-cart-drawer__swipe-remove" aria-hidden="true">Quitar</div>' +

              '<a href="' +
                itemUrl +
                '" class="cenit-cart-drawer__item">' +

                '<div class="cenit-cart-drawer__image">' +
                  image +
                '</div>' +

                '<div class="cenit-cart-drawer__item-info">' +

                  '<div class="cenit-cart-drawer__item-kicker">' + (window.cenitKindLabel ? window.cenitKindLabel(item) : 'TU ESTRELLA') + '</div>' +

                  '<div class="cenit-cart-drawer__item-title">' +
                    title +
                  '</div>' +

                  variant +

                  '<div class="cenit-cart-drawer__item-meta">' +
                    cenitLinePrice(item) +
                  '</div>' +

                '</div>' +

              '</a>' +

              '<div class="cenit-cart-drawer__qty" data-cenit-qty-wrap>' +
                '<button type="button" class="cenit-cart-drawer__qty-btn" data-cenit-qty-plus aria-label="Agregar una unidad">+</button>' +
                '<span class="cenit-cart-drawer__qty-value" data-cenit-qty-value>' +
                  Number(item.quantity || 0) +
                '</span>' +
                '<button type="button" class="cenit-cart-drawer__qty-btn" data-cenit-qty-minus aria-label="Quitar una unidad">−</button>' +
              '</div>' +



            '</div>'
          );

        }
      ).join('');

  }


  /* ========================================================
     UPDATE HEADER
  ======================================================== */

  window.cenitUpdateCartHeader =
    function(cart){

      if(!cart){
        return;
      }

      cenitApply3x2(cart);


      cenitRenderAccountCart(
        cart
      );


      cenitUpdateShippingProgress(
        cart
      );


      var cartLink =
        document.getElementById(
          'cenitHeaderCart'
        );


      var piecesText =
        cart.item_count === 1
          ? 'pieza'
          : 'piezas';


      if(cartLink){

        cartLink.innerHTML =
          '<div class="cenit-header__cart-icon" id="cenitHeaderCartIcon">' +

            '<svg viewBox="0 0 24 24">' +
              '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path>' +
              '<line x1="3" y1="6" x2="21" y2="6"></line>' +
              '<path d="M16 10a4 4 0 01-8 0"></path>' +
            '</svg>' +

            '<span class="cenit-header__account-badge' +
              (
                cart.item_count >
                0
                  ? ''
                  : ' is-empty'
              ) +
              '" id="cenitAccountCartBadge" aria-label="' +
              cart.item_count +
              ' productos en el carrito">' +
              cart.item_count +
            '</span>' +

          '</div>' +

          (
            cart.item_count >
            0
              ? '<div class="cenit-header__cart-info">' +
                  '<span class="cenit-header__cart-count">' +
                    cart.item_count +
                    ' ' +
                    piecesText +
                  '</span>' +

                  '<span class="cenit-header__cart-price">' +
                    cenitHeaderMoney(
                      cart.total_price
                    ) +
                  '</span>' +
                '</div>'

              : '<span class="cenit-header__cart-empty">Carrito</span>'
          );

      }


      var badge =
        document.getElementById(
          'cenitAccountCartBadge'
        );


      if(badge){

        badge.textContent =
          cart.item_count;


        badge.setAttribute(
          'aria-label',
          cart.item_count +
          ' productos en el carrito'
        );


        if(
          cart.item_count >
          0
        ){

          badge.classList.remove(
            'is-empty'
          );


          badge.classList.remove(
            'cenit-badge-pop'
          );


          void badge.offsetWidth;


          badge.classList.add(
            'cenit-badge-pop'
          );

        }else{

          badge.classList.add(
            'is-empty'
          );

        }

      }


      if(cartLink){

        cartLink.classList.remove(
          'cenit-cart-bump'
        );


        void cartLink.offsetWidth;


        cartLink.classList.add(
          'cenit-cart-bump'
        );


        setTimeout(
          function(){

            cartLink.classList.remove(
              'cenit-cart-bump'
            );

          },
          500
        );

      }

  };



  /* ========================================================
     UPDATE QUANTITY
  ======================================================== */

  function cenitChangeCartQuantity(key, quantity, shell){

    if(!key || !shell){
      return;
    }

    quantity = Math.max(0, Number(quantity) || 0);

    if(shell.dataset.updating === '1'){
      return;
    }

    shell.dataset.updating = '1';
    shell.style.opacity = '.65';

    fetch(
      cenitRoot() + 'cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          id:key,
          quantity:quantity
        })
      }
    )
    .then(function(response){

      if(!response.ok){
        throw new Error('No se pudo actualizar la cantidad.');
      }

      return response.json();

    })
    .then(function(cart){

      window.cenitUpdateCartHeader(cart);

      document.dispatchEvent(
        new CustomEvent(
          'cenit:cart-updated',
          {
            detail:{
              cart:cart
            }
          }
        )
      );

    })
    .catch(function(error){

      console.error(
        'CENIT: no se pudo actualizar la cantidad',
        error
      );

      shell.dataset.updating = '';
      shell.style.opacity = '';

    });

  }


  /* ========================================================
     REMOVE CART ITEM
  ======================================================== */

  function cenitRemoveCartItem(
    key,
    shell
  ){

    if(
      !key ||
      !shell ||
      shell.dataset.removing ===
      '1'
    ){
      return;
    }


    shell.dataset.removing =
      '1';


    shell.classList.add(
      'is-removing'
    );


    fetch(
      cenitRoot() +
      'cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },
        body:
          JSON.stringify({
            id:key,
            quantity:0
          })
      }
    )
    .then(
      function(response){

        if(!response.ok){

          throw new Error(
            'No se pudo quitar el producto.'
          );

        }

        return response.json();

      }
    )
    .then(
      function(cart){

        window.cenitUpdateCartHeader(
          cart
        );


        document.dispatchEvent(
          new CustomEvent(
            'cenit:cart-updated',
            {
              detail:{
                cart:cart
              }
            }
          )
        );

      }
    )
    .catch(
      function(error){

        console.error(
          'CENIT: no se pudo quitar el producto',
          error
        );


        shell.dataset.removing =
          '';


        shell.classList.remove(
          'is-removing'
        );


        var item =
          shell.querySelector(
            '.cenit-cart-drawer__item'
          );


        if(item){

          item.style.transform =
            '';

          item.style.transition =
            '';

        }

      }
    );

  }


  /* ========================================================
     REMOVE EVENTS + SWIPE
  ======================================================== */

  function cenitInitCartRemoval(){

    var itemsEl =
      document.getElementById(
        'cenitAccountCartItems'
      );


    if(
      !itemsEl ||
      itemsEl.dataset.removeReady ===
      '1'
    ){
      return;
    }


    itemsEl.dataset.removeReady =
      '1';


    itemsEl.addEventListener(
      'click',
      function(event){

        var qtyMinus =
          event.target.closest(
            '[data-cenit-qty-minus]'
          );

        var qtyPlus =
          event.target.closest(
            '[data-cenit-qty-plus]'
          );

        if(qtyMinus || qtyPlus){

          event.preventDefault();
          event.stopPropagation();

          var qtyShell =
            event.target.closest(
              '[data-cenit-cart-item]'
            );

          if(!qtyShell){
            return;
          }

          var qtyValueEl =
            qtyShell.querySelector(
              '[data-cenit-qty-value]'
            );

          var currentQty =
            qtyValueEl
              ? Number(qtyValueEl.textContent) || 0
              : 0;

          var nextQty =
            qtyPlus
              ? currentQty + 1
              : currentQty - 1;

          cenitChangeCartQuantity(
            qtyShell.dataset.cartKey,
            nextQty,
            qtyShell
          );

          return;
        }



        var itemLink =
          event.target.closest(
            '.cenit-cart-drawer__item'
          );


        if(itemLink){

          var itemShell =
            itemLink.closest(
              '[data-cenit-cart-item]'
            );


          if(
            itemShell &&
            itemShell.dataset.justSwiped ===
            '1'
          ){

            event.preventDefault();

            itemShell.dataset.justSwiped =
              '';

          }

        }

      }
    );


    var activeShell =
      null;

    var activeItem =
      null;

    var startX =
      0;

    var startY =
      0;

    var lastX =
      0;

    var horizontal =
      false;


    itemsEl.addEventListener(
      'touchstart',
      function(event){

        if(
          window.innerWidth >
          989 ||
          event.touches.length !==
          1
        ){
          return;
        }


        var item =
          event.target.closest(
            '.cenit-cart-drawer__item'
          );


        if(!item){
          return;
        }


        var shell =
          item.closest(
            '[data-cenit-cart-item]'
          );


        if(
          !shell ||
          shell.dataset.removing ===
          '1'
        ){
          return;
        }


        activeShell =
          shell;

        activeItem =
          item;

        startX =
          event.touches[0].clientX;

        startY =
          event.touches[0].clientY;

        lastX =
          startX;

        horizontal =
          false;


        activeItem.style.transition =
          'none';

      },
      {
        passive:true
      }
    );


    itemsEl.addEventListener(
      'touchmove',
      function(event){

        if(
          !activeShell ||
          !activeItem ||
          event.touches.length !==
          1
        ){
          return;
        }


        var x =
          event.touches[0].clientX;

        var y =
          event.touches[0].clientY;

        var dx =
          x -
          startX;

        var dy =
          y -
          startY;


        lastX =
          x;


        if(
          !horizontal &&
          Math.abs(dx) >
          8
        ){

          horizontal =
            Math.abs(dx) >
            Math.abs(dy);

        }


        if(!horizontal){
          return;
        }


        if(dx > 0){
          dx = 0;
        }


        dx =
          Math.max(
            dx,
            -105
          );


        event.preventDefault();


        activeItem.style.transform =
          'translate3d(' +
          dx +
          'px,0,0)';

      },
      {
        passive:false
      }
    );


    itemsEl.addEventListener(
      'touchend',
      function(){

        if(
          !activeShell ||
          !activeItem
        ){
          return;
        }


        var dx =
          lastX -
          startX;


        var shell =
          activeShell;


        var item =
          activeItem;


        item.style.transition =
          'transform .22s ease, opacity .22s ease';


        if(
          horizontal &&
          dx <=
          -62
        ){

          shell.dataset.justSwiped =
            '1';


          item.style.transform =
            'translate3d(-110%,0,0)';


          setTimeout(
            function(){

              cenitRemoveCartItem(
                shell.dataset.cartKey,
                shell
              );

            },
            150
          );

        }else{

          item.style.transform =
            '';

        }


        activeShell =
          null;

        activeItem =
          null;

        horizontal =
          false;

        startX =
          0;

        startY =
          0;

        lastX =
          0;

      },
      {
        passive:true
      }
    );


    itemsEl.addEventListener(
      'touchcancel',
      function(){

        if(activeItem){

          activeItem.style.transition =
            'transform .22s ease';

          activeItem.style.transform =
            '';

        }


        activeShell =
          null;

        activeItem =
          null;

        horizontal =
          false;

      },
      {
        passive:true
      }
    );

  }


  /* ========================================================
     FLY TO CART
  ======================================================== */

  window.cenitAnimateToCart =
    function(fallbackSource){

      var cart =
        document.getElementById(
          'cenitHeaderCart'
        );


      if(!cart){
        return;
      }


      var source =
        document.querySelector(
          '#cenitMainImg img.active'
        ) ||
        fallbackSource;


      if(!source){
        return;
      }


      var start =
        source.getBoundingClientRect();


      var end =
        cart.getBoundingClientRect();


      if(
        !start.width ||
        !start.height ||
        !end.width ||
        !end.height
      ){
        return;
      }


      var isImage =
        source.tagName &&
        source.tagName.toLowerCase() ===
        'img';


      var flyer =
        isImage
          ? source.cloneNode(
              true
            )
          : document.createElement(
              'div'
            );


      flyer.classList.add(
        'cenit-fly-to-cart'
      );


      var size =
        Math.max(
          38,
          Math.min(
            72,
            Math.min(
              start.width,
              start.height
            ) *
            .18
          )
        );


      var startX =
        start.left +
        start.width / 2 -
        size / 2;


      var startY =
        start.top +
        start.height / 2 -
        size / 2;


      var endX =
        end.left +
        end.width / 2 -
        size / 2;


      var endY =
        end.top +
        end.height / 2 -
        size / 2;


      flyer.style.left =
        startX +
        'px';

      flyer.style.top =
        startY +
        'px';

      flyer.style.width =
        size +
        'px';

      flyer.style.height =
        size +
        'px';


      if(!isImage){

        flyer.style.background =
          'var(--cenit-bronze)';

      }


      document.body.appendChild(
        flyer
      );


      var dx =
        endX -
        startX;


      var dy =
        endY -
        startY;


      var animation =
        flyer.animate(
          [
            {
              transform:
                'translate3d(0,0,0) scale(1)',
              opacity:1
            },
            {
              transform:
                'translate3d(' +
                dx * .55 +
                'px,' +
                (
                  dy * .45 -
                  45
                ) +
                'px,0) scale(.72)',
              opacity:.9,
              offset:.55
            },
            {
              transform:
                'translate3d(' +
                dx +
                'px,' +
                dy +
                'px,0) scale(.16)',
              opacity:.15
            }
          ],
          {
            duration:720,
            easing:
              'cubic-bezier(.22,.61,.36,1)',
            fill:'forwards'
          }
        );


      animation.onfinish =
        function(){

          flyer.remove();

        };

    };


  /* ========================================================
     INIT
  ======================================================== */

  cenitMountDrawer();

  cenitMountAccountMenu();

  cenitInitCartRemoval();

  cenitInitAnnouncements();

  cenitInitSearch();

  cenitUpdateShippingProgress({
    total_price:
      (window.CENIT_CART_TOTAL || 0)
  });


  document.addEventListener(
    'shopify:section:load',
    function(){

      setTimeout(
        cenitMountDrawer,
        0
      );

      setTimeout(
        cenitMountAccountMenu,
        0
      );

      setTimeout(
        cenitInitCartRemoval,
        0
      );

      setTimeout(
        cenitInitAnnouncements,
        0
      );

      setTimeout(
        cenitInitSearch,
        0
      );


      setTimeout(
        function(){

          cenitFetchCart()
          .then(
            cenitUpdateShippingProgress
          )
          .catch(
            function(){}
          );

        },
        0
      );

    }
  );


  document.addEventListener(
    'click',
    function(event){

      var checkout =
        event.target.closest &&
        event.target.closest(
          '#cenitAccountCheckout.is-disabled'
        );


      if(checkout){

        event.preventDefault();

      }

    }
  );


  document.addEventListener(
    'keydown',
    function(event){

      if(
        event.key ===
        'Escape'
      ){

        window.cenitCloseDrawer();

        window.cenitCloseAccountMenu();

        window.cenitCloseSearch();

      }

    }
  );


  document.addEventListener(
    'cenit:cart-updated',
    function(event){

      if(
        event.detail &&
        event.detail.cart
      ){

        window.cenitUpdateCartHeader(
          event.detail.cart
        );

      }else{

        cenitFetchCart()
        .then(
          window.cenitUpdateCartHeader
        )
        .catch(
          function(){}
        );

      }

    }
  );

})();

/* Contador de fin de promos (Configuración del tema > CENIT · Categorías > Contador).
   Fecha en hora del centro de México (UTC-6). Al terminar, el aviso desaparece. */
(function(){
  var els = document.querySelectorAll('[data-cenit-countdown]');
  if(!els.length) return;
  function parse(str){
    var m = String(str).match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if(!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], (m[4] ? +m[4] : 23) + 6, m[5] ? +m[5] : 59);
  }
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function tick(){
    var alive = false;
    els.forEach(function(el){
      var end = parse(el.getAttribute('data-cenit-countdown'));
      var left = end - Date.now();
      if(isNaN(end) || left <= 0){ el.remove(); return; }
      alive = true;
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mi = Math.floor(s % 3600 / 60), se = s % 60;
      var out = el.querySelector('[data-cenit-countdown-out]');
      if(out) out.textContent = (d ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ':' + pad(mi) + ':' + pad(se);
    });
    if(alive) setTimeout(tick, 1000);
  }
  tick();
})();

